import  types from './all-mutation-types'
import Vue  from 'vue'
import { MutationTree } from 'vuex/types'
import { IClientState } from './state'
import { toNumberDictionary, toStringDictionary } from '@/utils/groupBy'
import { buildStateItem } from '@/models/alo/StateItem'
import { QtyItem } from '@/models/ui/QtyItem'
import { AloForfait } from '@/models/alo/AloForfait'
import { AloPanier } from '@/models/alo/AloPanier'
import { AloAddress } from '@/models/alo/AloAddress'




const mutations: MutationTree<IClientState> = {
    [types.CLIENT_ADD_PANIER]: (state,item:QtyItem<AloForfait>) => {            
        //recherche dans le panier si un plat avec la meme config a déjà été ajouté          
        const itemPanier = state.panier.items.find(it => it.item.id == item.item.id)
        if(itemPanier) {
            itemPanier.qty++;
            itemPanier.psnId = item.psnId
        }
        else {
            state.panier.items.push(item)  
        }        
        localStorage.setItem('aqua_panier',JSON.stringify(state.panier))      
    },
    [types.CLIENT_UPD_PANIER_ITEM_QTY]: (state,{fftId,qty}:{fftId:number,qty:number}) => { 
        if (qty>0) 
            state.panier.items.find(it => it.item.id == fftId)!.qty = qty
        else {
            state.panier.items.splice( state.panier.items.findIndex(it => it.item.id == fftId),1)            
        }
        localStorage.setItem('aqua_panier',JSON.stringify(state.panier))
    },    
    [types.CLIENT_CLEAR_PANIER]: (state) => { 
        state.panier = new AloPanier()
        localStorage.setItem('aqua_panier',JSON.stringify(state.panier))
    },
    [types.CLIENT_CHECKOUT_REQUEST]: state => {    
        state.panierStatus = "Génération de l'intention de paiement"
    },
    [types.CLIENT_CHECKOUT_SUCCESS]: (state, panier:AloPanier) => {         
        state.panier = panier
        state.panierStatus = "Génération de l'intention de paiement terminée"
        localStorage.setItem('aqua_panier',JSON.stringify(state.panier))
    },
    [types.CLIENT_CHECKOUT_ERROR]: state => {        
        state.panierStatus = "Erreur lors de la génération de l'intention de paiement"
    },  
    [types.CLIENT_CHECKOUT_FREE_REQUEST]: state => {    
        state.panierStatus = "Validation de la commande"
    },
    [types.CLIENT_CHECKOUT_FREE_SUCCESS]: (state, panier:AloPanier) => {         
        state.panier = panier
        state.panierStatus = "Validation de la commande terminée"
        localStorage.setItem('aqua_panier',JSON.stringify(state.panier))
    },
    [types.CLIENT_CHECKOUT_ERROR]: state => {        
        state.panierStatus = "Erreur lors de la validation de la commande"
    },  
    [types.CLIENT_SET_PANIER_ADDRESS]: (state, address:AloAddress) => {        
        state.panier.address = address
        localStorage.setItem('aqua_panier',JSON.stringify(state.panier))
    },  
          
}

export default mutations